import { render } from "./Copyright.vue?vue&type=template&id=ef2ef2bc&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=ef2ef2bc&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2ef2bc"]])

export default __exports__